// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] || chunkId) + "." + {"43":"fe93c2f7","234":"507a6c19","488":"b90d1a66","653":"bbea32e5","844":"a72a3d61"}[chunkId] + ".chunk.js";
};